/* ----------------------------------- */ 
// Domain import pattern. Please       //
// follow below usage for all reducers // 
/* ----------------------------------- */
import * as Products_Domain_Types               from '../../../domain/products/actions/types';
import { createReducer }                        from 'redux-immutablejs';
import { fromJS }                               from 'immutable';

const initial = fromJS({
    brands      : [],
    tags        : [],
    categories  : []
});

const products =  createReducer(initial, {
    [Products_Domain_Types.UPDATE_PRODUCT_DOMAIN_DATA]: (state, action) => 
        state.merge({
            brands      : action.payload.data.brands,
            tags        : action.payload.data.tags,
            categories  : action.payload.data.categories
        }),
});

export default products;